export const classes = {
  title: 'text-grey-8',
  xs: 'text-base font-medium',
  sm: 'text-xl font-semibold',
  lg: 'text-2xl font-bold',
};
